import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AssetManagementObject, FuelType, VehicleStatus } from 'app/interfaces/asset-management/asset-management-object.interface';
import { RequestManagementObject } from 'app/interfaces/request-management/request-management-object.interface';

@Component({
    selector: 'request-management-dialog.component',
    templateUrl: './request-management-dialog.component.html',
    styleUrls: [
        './request-management-dialog.component.css'
    ]
})
export class RequestManagementDialogComponent {
    dialogTitle: string;

    requestManagementForm: FormGroup;

    fuelTypes: string[] = Object.values(FuelType);
    vehicleStatuses: string[] = Object.values(VehicleStatus);

    constructor(public dialogRef: MatDialogRef<RequestManagementDialogComponent>, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data?: RequestManagementObject) {
        this.dialogTitle = data ? 'Update Requestor Information' : 'Add Requestor Information';
        
        this.requestManagementForm = this.formBuilder.group({
            requestorName: ['', Validators.required],
            telephoneNumber: ['',  [Validators.required, Validators.pattern('[- +()0-9]+')]],
            companyName: ['', Validators.required],
            fmnoNumber: ['', Validators.required],
            customChargeCode: ['', Validators.required],
        });

        if (this.data) {
            this.requestManagementForm.patchValue(this.data);
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.requestManagementForm.markAllAsTouched();
        if (this.requestManagementForm.valid) {
            var requestManagementObject: RequestManagementObject = this.requestManagementForm.value;

            if (this.data) {
                requestManagementObject.key = this.data.key;
            }

            requestManagementObject.customChargeCode = requestManagementObject.customChargeCode.trim();
            requestManagementObject.fmnoNumber = requestManagementObject.fmnoNumber.trim();
            requestManagementObject.requestorName = requestManagementObject.requestorName.trim();
            requestManagementObject.telephoneNumber = requestManagementObject.telephoneNumber.trim();
            requestManagementObject.companyName = requestManagementObject.companyName.trim();

            this.dialogRef.close(requestManagementObject);
        }
    }
}